import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ref, onValue, get, set, update } from 'firebase/database';
import { db } from '../firebase/config';


const Customers = () => {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [error, setError] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);

  // New states for order details
  const [customerOrders, setCustomerOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(false);

  // States for adding new customer
  const [showAddCustomerModal, setShowAddCustomerModal] = useState(false);
  const [redirectToQuotation, setRedirectToQuotation] = useState(true);
  const [showQuotationModal, setShowQuotationModal] = useState(false);
  const [quotationCustomer, setQuotationCustomer] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    landmark: '',
    city: '',
    state: '',
    district: '',
    postalCode: '',
    birthDate: ''
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // States for editing customer
  const [isEditMode, setIsEditMode] = useState(false);
  const [editFormData, setEditFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    landmark: '',
    city: '',
    state: '',
    district: '',
    postalCode: '',
    birthDate: ''
  });
  const [editValidationErrors, setEditValidationErrors] = useState({});

  // Indian states and districts data
  const indianStates = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
    "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
    "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
    "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
    "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
  ];

  const stateDistricts = {
    "Andhra Pradesh": ["Anantapur", "Chittoor", "East Godavari", "Guntur", "Krishna", "Kurnool", "Nellore", "Prakasam", "Srikakulam", "Visakhapatnam", "Vizianagaram", "West Godavari", "YSR Kadapa"],
    "Arunachal Pradesh": ["Tawang", "West Kameng", "East Kameng", "Papum Pare", "Lower Subansiri", "Upper Subansiri", "West Siang", "East Siang", "Siang", "Upper Siang", "Lower Siang", "Lower Dibang Valley", "Upper Dibang Valley", "Tirap", "Changlang", "Longding", "Lohit", "Namsai", "Anjaw"],
    "Assam": ["Baksa", "Barpeta", "Biswanath", "Bongaigaon", "Cachar", "Charaideo", "Chirang", "Darrang", "Dhemaji", "Dhubri", "Dibrugarh", "Goalpara", "Golaghat", "Hailakandi", "Hojai", "Jorhat", "Kamrup", "Kamrup Metropolitan", "Karbi Anglong", "Karimganj", "Kokrajhar", "Lakhimpur", "Majuli", "Morigaon", "Nagaon", "Nalbari", "Sivasagar", "Sonitpur", "South Salmara Mankachar", "Tinsukia", "Udalguri", "West Karbi Anglong"],
    "Bihar": ["Araria", "Arwal", "Aurangabad", "Banka", "Begusarai", "Bhagalpur", "Bhojpur", "Buxar", "Darbhanga", "East Champaran", "Gaya", "Gopalganj", "Jamui", "Jehanabad", "Kaimur", "Katihar", "Khagaria", "Kishanganj", "Lakhisarai", "Madhepura", "Madhubani", "Munger", "Muzaffarpur", "Nalanda", "Nawada", "Patna", "Purnia", "Rohtas", "Saharsa", "Samastipur", "Saran", "Sheikhpura", "Sheohar", "Sitamarhi", "Siwan", "Supaul", "Vaishali", "West Champaran"],
    "Chhattisgarh": ["Balod", "Baloda Bazar", "Balrampur", "Bastar", "Bemetara", "Bijapur", "Bilaspur", "Dantewada", "Dhamtari", "Durg", "Gariaband", "Janjgir Champa", "Jashpur", "Kabirdham", "Kanker", "Kondagaon", "Korba", "Koriya", "Mahasamund", "Mungeli", "Narayanpur", "Raigarh", "Raipur", "Rajnandgaon", "Sukma", "Surajpur", "Surguja"],
    "Goa": ["North Goa", "South Goa"],
    "Gujarat": ["Ahmedabad", "Amreli", "Anand", "Aravalli", "Banaskantha", "Bharuch", "Bhavnagar", "Botad", "Chhota Udaipur", "Dahod", "Devbhoomi Dwarka", "Gandhinagar", "Gir Somnath", "Jamnagar", "Junagadh", "Kheda", "Kutch", "Mahisagar", "Mehsana", "Morbi", "Narmada", "Navsari", "Panchmahal", "Patan", "Porbandar", "Rajkot", "Sabarkantha", "Surat", "Surendranagar", "Tapi", "Vadodara", "Valsad"],
    "Haryana": ["Ambala", "Bhiwani", "Charkhi Dadri", "Faridabad", "Fatehabad", "Gurugram", "Hisar", "Jhajjar", "Jind", "Kaithal", "Karnal", "Kurukshetra", "Mahendragarh", "Nuh", "Palwal", "Panchkula", "Panipat", "Rewari", "Rohtak", "Sirsa", "Sonipat", "Yamunanagar"],
    "Himachal Pradesh": ["Bilaspur", "Chamba", "Hamirpur", "Kangra", "Kinnaur", "Kullu", "Lahaul and Spiti", "Mandi", "Shimla", "Sirmaur", "Solan", "Una"],
    "Jharkhand": ["Bokaro", "Chatra", "Deoghar", "Dhanbad", "Dumka", "East Singhbhum", "Garhwa", "Giridih", "Godda", "Gumla", "Hazaribagh", "Jamtara", "Khunti", "Koderma", "Latehar", "Lohardaga", "Pakur", "Palamu", "Ramgarh", "Ranchi", "Sahibganj", "Seraikela Kharsawan", "Simdega", "West Singhbhum"],
    "Karnataka": ["Bagalkot", "Bangalore Rural", "Bangalore Urban", "Belagavi", "Ballari", "Bidar", "Chamarajanagar", "Chikballapur", "Chikkamagaluru", "Chitradurga", "Dakshina Kannada", "Davanagere", "Dharwad", "Gadag", "Hassan", "Haveri", "Kalaburagi", "Kodagu", "Kolar", "Koppal", "Mandya", "Mysuru", "Raichur", "Ramanagara", "Shivamogga", "Tumakuru", "Uttara Kannada", "Vijayapura", "Yadgir"],
    "Kerala": ["Alappuzha", "Ernakulam", "Idukki", "Kannur", "Kasaragod", "Kollam", "Kottayam", "Kozhikode", "Malappuram", "Palakkad", "Pathanamthitta", "Thiruvananthapuram", "Thrissur", "Wayanad"],
    "Madhya Pradesh": ["Agar Malwa", "Alirajpur", "Anuppur", "Ashoknagar", "Balaghat", "Barwani", "Betul", "Bhind", "Bhopal", "Burhanpur", "Chhatarpur", "Chhindwara", "Damoh", "Datia", "Dewas", "Dhar", "Dindori", "Guna", "Gwalior", "Harda", "Hoshangabad", "Indore", "Jabalpur", "Jhabua", "Katni", "Khandwa", "Khargone", "Mandla", "Mandsaur", "Morena", "Narsinghpur", "Neemuch", "Panna", "Raisen", "Rajgarh", "Ratlam", "Rewa", "Sagar", "Satna", "Sehore", "Seoni", "Shahdol", "Shajapur", "Sheopur", "Shivpuri", "Sidhi", "Singrauli", "Tikamgarh", "Ujjain", "Umaria", "Vidisha"],
    "Maharashtra": ["Ahmednagar", "Akola", "Amravati", "Aurangabad", "Beed", "Bhandara", "Buldhana", "Chandrapur", "Dhule", "Gadchiroli", "Gondia", "Hingoli", "Jalgaon", "Jalna", "Kolhapur", "Latur", "Mumbai City", "Mumbai Suburban", "Nagpur", "Nanded", "Nandurbar", "Nashik", "Osmanabad", "Palghar", "Parbhani", "Pune", "Raigad", "Ratnagiri", "Sangli", "Satara", "Sindhudurg", "Solapur", "Thane", "Wardha", "Washim", "Yavatmal"],
    "Manipur": ["Bishnupur", "Chandel", "Churachandpur", "Imphal East", "Imphal West", "Jiribam", "Kakching", "Kangpokpi", "None", "Pherzawl", "Senapati", "Tamenglong", "Tengnoupal", "Thoubal", "Ukhrul"],
    "Meghalaya": ["East Garo Hills", "East Jaintia Hills", "East Khasi Hills", "North Garo Hills", "Ri Bhoi", "South Garo Hills", "South Jaintia Hills", "South West Garo Hills", "South West Khasi Hills", "West Garo Hills", "West Jaintia Hills", "West Khasi Hills"],
    "Mizoram": ["Aizawl", "Champhai", "Kolasib", "Lawngtlai", "Lunglei", "Mamit", "Saiha", "Serchhip"],
    "Nagaland": ["Dimapur", "Kiphire", "Kohima", "Longleng", "Mokokchung", "Mon", "Peren", "Phek", "Tuensang", "Wokha", "Zunheboto"],
    "Odisha": ["Angul", "Balangir", "Balasore", "Bargarh", "Bhadrak", "Boudh", "Cuttack", "Deogarh", "Dhenkanal", "Gajapati", "Ganjam", "Jagatsinghpur", "Jajpur", "Jharsuguda", "Kalahandi", "Kandhamal", "Kendrapara", "Kendujhar", "Khordha", "Koraput", "Malkangiri", "Mayurbhanj", "Nabarangpur", "Nayagarh", "Nuapada", "Puri", "Rayagada", "Sambalpur", "Sonepur", "Sundargarh"],
    "Punjab": ["Amritsar", "Barnala", "Bathinda", "Faridkot", "Fatehgarh Sahib", "Fazilka", "Ferozepur", "Gurdaspur", "Hoshiarpur", "Jalandhar", "Kapurthala", "Ludhiana", "Mansa", "Moga", "Mohali", "Muktsar", "Nawanshahr", "Pathankot", "Patiala", "Rupnagar", "Sangrur", "Shahid Bhagat Singh Nagar", "Tarn Taran"],
    "Rajasthan": ["Ajmer", "Alwar", "Banswara", "Baran", "Barmer", "Bharatpur", "Bhilwara", "Bikaner", "Bundi", "Chittorgarh", "Churu", "Dausa", "Dholpur", "Dungarpur", "Hanumangarh", "Jaipur", "Jaisalmer", "Jalore", "Jhalawar", "Jhunjhunu", "Jodhpur", "Karauli", "Kota", "Nagaur", "Pali", "Pratapgarh", "Rajsamand", "Sawai Madhopur", "Sikar", "Sirohi", "Sri Ganganagar", "Tonk", "Udaipur"],
    "Sikkim": ["East Sikkim", "North Sikkim", "South Sikkim", "West Sikkim"],
    "Tamil Nadu": ["Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri", "Dindigul", "Erode", "Kallakurichi", "Kanchipuram", "Kanyakumari", "Karur", "Krishnagiri", "Madurai", "Nagapattinam", "Namakkal", "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga", "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Tiruchirappalli", "Tirunelveli", "Tirupathur", "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore", "Viluppuram", "Virudhunagar"],
    "Telangana": ["Adilabad", "Bhadradri Kothagudem", "Hyderabad", "Jagtial", "Jangaon", "Jayashankar Bhupalapally", "Jogulamba Gadwal", "Kamareddy", "Karimnagar", "Khammam", "Kumuram Bheem", "Mahabubabad", "Mahabubnagar", "Mancherial", "Medak", "Medchal Malkajgiri", "Mulugu", "Nagarkurnool", "Nalgonda", "Narayanpet", "Nirmal", "Nizamabad", "Peddapalli", "Rajanna Sircilla", "Rangareddy", "Sangareddy", "Siddipet", "Suryapet", "Vikarabad", "Wanaparthy", "Warangal Rural", "Warangal Urban", "Yadadri Bhuvanagiri"],
    "Tripura": ["Dhalai", "Gomati", "Khowai", "North Tripura", "Sepahijala", "South Tripura", "Unakoti", "West Tripura"],
    "Uttar Pradesh": ["Agra", "Aligarh", "Allahabad", "Ambedkar Nagar", "Amethi", "Amroha", "Auraiya", "Ayodhya", "Baghpat", "Bahraich", "Ballia", "Balrampur", "Banda", "Barabanki", "Bareilly", "Basti", "Bhadohi", "Bijnor", "Budaun", "Bulandshahr", "Chandauli", "Chitrakoot", "Deoria", "Etah", "Etawah", "Farrukhabad", "Fatehpur", "Firozabad", "Gautam Buddha Nagar", "Ghaziabad", "Ghazipur", "Gonda", "Gorakhpur", "Hamirpur", "Hapur", "Hardoi", "Hathras", "Jalaun", "Jaunpur", "Jhansi", "Kannauj", "Kanpur Dehat", "Kanpur Nagar", "Kasganj", "Kaushambi", "Kheri", "Kushinagar", "Lalitpur", "Lucknow", "Mau", "Meerut", "Mirzapur", "Moradabad", "Muzaffarnagar", "Pilibhit", "Pratapgarh", "Raebareli", "Rampur", "Saharanpur", "Sambhal", "Shahjahanpur", "Shravasti", "Siddharthnagar", "Sitapur", "Sonbhadra", "Sultanpur", "Unnao", "Varanasi"],
    "Uttarakhand": ["Almora", "Bageshwar", "Chamoli", "Champawat", "Dehradun", "Haridwar", "Nainital", "Pauri Garhwal", "Pithoragarh", "Rudraprayag", "Tehri Garhwal", "Udham Singh Nagar", "Uttarkashi"],
    "West Bengal": ["Alipurduar", "Bankura", "Birbhum", "Burdwan", "Cooch Behar", "Dakshin Dinajpur", "Darjeeling", "Hooghly", "Howrah", "Jalpaiguri", "Jhargram", "Kalimpong", "Kolkata", "Malda", "Murshidabad", "Nadia", "North 24 Parganas", "Paschim Bardhaman", "Paschim Medinipur", "Purba Bardhaman", "Purba Medinipur", "Purulia", "South 24 Parganas", "Uttar Dinajpur"],
    "Andaman and Nicobar Islands": ["Nicobar", "North and Middle Andaman", "South Andaman"],
    "Chandigarh": ["Chandigarh"],
    "Dadra and Nagar Haveli and Daman and Diu": ["Dadra and Nagar Haveli", "Daman", "Diu"],
    "Delhi": ["Central Delhi", "East Delhi", "New Delhi", "North Delhi", "North East Delhi", "North West Delhi", "South Delhi", "South East Delhi", "South West Delhi", "West Delhi"],
    "Jammu and Kashmir": ["Anantnag", "Bandipora", "Baramulla", "Budgam", "Doda", "Ganderbal", "Jammu", "Kargil", "Kathua", "Kishtwar", "Kulgam", "Kupwara", "Leh", "Poonch", "Pulwama", "Rajouri", "Ramban", "Reasi", "Samba", "Shopian", "Srinagar", "Udhampur"],
    "Ladakh": ["Kargil", "Leh"],
    "Lakshadweep": ["Lakshadweep"],
    "Puducherry": ["Karaikal", "Mahe", "Puducherry", "Yanam"]
  };

  // Sorting, filtering, and pagination states
  const [sortBy, setSortBy] = useState('date');
  const [sortOrder, setSortOrder] = useState('desc');
  const [statusFilter, setStatusFilter] = useState('all');
  const [dateFilter, setDateFilter] = useState('all');
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 20;

  // Helper function to format address object to string
  const formatAddress = (address) => {
    if (!address || typeof address === 'string') {
      return address || 'N/A';
    }

    const parts = [];
    if (address.street) parts.push(address.street);
    if (address.landmark) parts.push(address.landmark);
    if (address.city) parts.push(address.city);
    if (address.state) parts.push(address.state);
    if (address.postalCode) parts.push(address.postalCode);

    return parts.length > 0 ? parts.join(', ') : 'N/A';
  };

  // Validation functions
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^[6-9]\d{9}$/;
    return phoneRegex.test(phone);
  };

  const validatePostalCode = (postalCode) => {
    const postalRegex = /^[1-9][0-9]{5}$/;
    return postalRegex.test(postalCode);
  };

  const validateName = (name) => {
    const nameRegex = /^[a-zA-Z\s]{2,50}$/;
    return nameRegex.test(name.trim());
  };

  const validateCityState = (value) => {
    const cityStateRegex = /^[a-zA-Z\s]{2,30}$/;
    return cityStateRegex.test(value.trim());
  };

  const validateField = (fieldName, value) => {
    switch (fieldName) {
      case 'name':
        if (!value.trim()) return 'Name is required';
        if (!validateName(value)) return 'Name should only contain letters and spaces (2-50 characters)';
        return '';

      case 'email':
        if (!value.trim()) return 'Email is required';
        if (!validateEmail(value)) return 'Please enter a valid email address';
        return '';

      case 'phone':
        if (!value.trim()) return 'Phone number is required';
        if (!validatePhone(value)) return 'Please enter a valid 10-digit mobile number';
        return '';

      case 'address':
        if (!value.trim()) return 'Address is required';
        if (value.trim().length < 10) return 'Address must be at least 10 characters long';
        return '';

      case 'city':
        if (!value.trim()) return 'City is required';
        if (!validateCityState(value)) return 'City name should only contain letters and spaces (2-30 characters)';
        return '';

      case 'state':
        if (!value.trim()) return 'State is required';
        return '';

      case 'district':
        if (!value.trim()) return 'District is required';
        return '';

      case 'postalCode':
        if (!value.trim()) return 'Postal code is required';
        if (!validatePostalCode(value)) return 'Please enter a valid 6-digit PIN code';
        return '';

      case 'birthDate':
        // Birth date is optional, so no validation needed
        return '';

      default:
        return '';
    }
  };

  const validateForm = () => {
    const errors = {};
    Object.keys(formData).forEach(key => {
      const error = validateField(key, formData[key]);
      if (error) {
        errors[key] = error;
      }
    });
    return errors;
  };

  const makeCustomerRow = (customer, phone) => {
    const orderCount = Object.keys(customer.myOrders || {}).length;
    return {
      id: phone,
      name: customer.name || 'N/A',
      email: customer.email || 'N/A',
      phone,
      address: formatAddress(customer.address),
      customerId: customer.customerId || 'N/A',
      birthDate: customer.birthDate ? new Date(customer.birthDate).toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }) : null,
      purchasedProduct: orderCount > 0 ? 'Multiple Products' : 'No Orders',
      quantity: orderCount,
      totalAmount: 0,
      date: customer.createdAt ? new Date(customer.createdAt).toLocaleDateString() : 'N/A',
      paymentMethod: 'N/A',
      status: orderCount > 0 ? 'Has Orders' : 'No Orders',
      placedBy: 'N/A',
    };
  };

  // Function to fetch customer orders
  const fetchCustomerOrders = async (customer) => {
    setLoadingOrders(true);
    setCustomerOrders([]);

    try {
      const ordersData = [];
      const customerData = await get(ref(db, `HTAMS/customers/${customer.phone}`));

      if (customerData.exists()) {
        const myOrders = customerData.val().myOrders || {};
        const orderIds = Object.keys(myOrders);

        const orderPromises = orderIds.map(async (orderId) => {
          try {
            const orderSnapshot = await get(ref(db, `HTAMS/orders/${orderId}`));
            if (orderSnapshot.exists()) {
              return {
                id: orderId,
                ...orderSnapshot.val()
              };
            }
          } catch (error) {
            console.error(`Error fetching order ${orderId}:`, error);
          }
          return null;
        });

        const orders = await Promise.all(orderPromises);
        const validOrders = orders.filter(order => order !== null);

        validOrders.sort((a, b) => {
          const dateA = new Date(a.orderDate || a.date || a.createdAt || 0);
          const dateB = new Date(b.orderDate || b.date || b.createdAt || 0);
          return dateB - dateA; // Latest orders first (descending order)
        });

        setCustomerOrders(validOrders);
      }
    } catch (error) {
      console.error('Error fetching customer orders:', error);
      setCustomerOrders([]);
    } finally {
      setLoadingOrders(false);
    }
  };

  // Form handlers for adding new customer
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // If state is changed, clear the district selection
    if (name === 'state') {
      setFormData(prev => ({
        ...prev,
        [name]: value,
        district: '' // Clear district when state changes
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }

    // Clear validation error for this field when user starts typing
    if (validationErrors[name]) {
      setValidationErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleAddCustomer = async () => {
    // Validate form
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      const htamsUser = JSON.parse(localStorage.getItem('htamsUser') || '{}');
      const currentUid = htamsUser?.uid;

      if (!currentUid) {
        setError('User not logged in.');
        return;
      }

      // Check if customer with this phone already exists
      const customerRef = ref(db, `HTAMS/customers/${formData.phone}`);
      const customerSnapshot = await get(customerRef);

      if (customerSnapshot.exists()) {
        setError('A customer with this phone number already exists.');
        return;
      }

      // Construct customer data
      const customerData = {
        name: formData.name.trim(),
        email: formData.email.trim().toLowerCase(),
        phone: formData.phone.trim(),
        address: {
          street: formData.address.trim(),
          landmark: formData.landmark.trim(),
          city: formData.city.trim(),
          state: formData.state.trim(),
          district: formData.district.trim(),
          postalCode: formData.postalCode.trim()
        },
        birthDate: formData.birthDate,
        customerId: `CUST-${Date.now()}`,
        createdAt: new Date().toISOString(),
        createdBy: currentUid,
        myOrders: {},
        status: 'active'
      };

      // Save customer to Firebase
      await set(customerRef, customerData);

      // Reset form and close modal
      setFormData({
        name: '',
        email: '',
        phone: '',
        address: '',
        landmark: '',
        city: '',
        state: '',
        district: '',
        postalCode: '',
        birthDate: ''
      });
      setValidationErrors({});
      setShowAddCustomerModal(false);

      // Show success message
      alert('Customer added successfully!');

      // Open quotation modal if checkbox is checked
      if (redirectToQuotation) {
        const preselectCustomer = {
          id: customerData.phone,
          name: customerData.name,
          email: customerData.email,
          phone: customerData.phone,
          address: `${customerData.address.street || ''}${customerData.address.landmark ? ', ' + customerData.address.landmark : ''}`,
          city: customerData.address.city,
          state: customerData.address.state,
          pincode: customerData.address.postalCode,
          company: customerData.company || ''
        };

        setQuotationCustomer(preselectCustomer);
        setShowQuotationModal(true);
      }

    } catch (error) {
      console.error('Error adding customer:', error);
      setError('Failed to add customer. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      address: '',
      landmark: '',
      city: '',
      state: '',
      district: '',
      postalCode: '',
      birthDate: ''
    });
    setValidationErrors({});
    setError('');
  };

  const openAddCustomerModal = () => {
    resetForm();
    setShowAddCustomerModal(true);
  };

  useEffect(() => {
    const htamsUser = JSON.parse(localStorage.getItem('htamsUser') || '{}');
    const currentUid = htamsUser?.uid;

    if (!currentUid) {
      setError('User not logged in.');
      setLoading(false);
      return;
    }

    const userRef = ref(db, `HTAMS/users/${currentUid}`);
    get(userRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const role = snapshot.val().role || '';
          setIsAdmin(role === 'Admin' || role === 'Company' || role === 'subadmin');
        }
      })
      .catch(() => {
        setError('Failed to fetch user data.');
      });

    const customersRef = ref(db, 'HTAMS/customers');
    const unsubscribe = onValue(
      customersRef,
      async (snapshot) => {
        const customersData = snapshot.val();
        console.log('🔍 Customer data from Firebase:', customersData);
        console.log('📊 Total customers in Firebase:', customersData ? Object.keys(customersData).length : 0);
        console.log('👤 Current user UID:', currentUid);
        console.log('🔑 Is Admin:', isAdmin);

        if (!customersData) {
          setError('No customer data found.');
          setLoading(false);
          return;
        }

        const allCustomers = [];

        // Simply fetch ALL customers without filtering
        for (const phone in customersData) {
          const customer = customersData[phone];
          console.log(`📱 Processing customer ${phone}:`, customer);

          // Add all customers to the list
          allCustomers.push(makeCustomerRow(customer, phone));
          console.log(`✅ Added customer ${phone}`);
        }

        console.log('✅ Final customers list:', allCustomers.length, allCustomers);
        setCustomers(allCustomers);
        applyFiltersAndSort(allCustomers);
        setLoading(false);

        if (allCustomers.length === 0) {
          setError('No customers found.');
        } else {
          setError('');
        }
      },
      (error) => {
        console.error('❌ Error fetching customers:', error);
        setError('Failed to fetch customer data.');
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [isAdmin]);

  const handleSearch = () => {
    applyFiltersAndSort(customers);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    if (!e.target.value.trim()) {
      applyFiltersAndSort(customers);
    }
  };

  // Pagination calculations
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentCustomers = filteredCustomers.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredCustomers.length / recordsPerPage);

  const applyFiltersAndSort = (data) => {
    let filtered = [...data];

    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      filtered = filtered.filter(
        (customer) =>
          customer.name.toLowerCase().includes(query) ||
          customer.email.toLowerCase().includes(query) ||
          customer.phone.toLowerCase().includes(query) ||
          customer.customerId.toLowerCase().includes(query)
      );
    }

    if (statusFilter !== 'all') {
      filtered = filtered.filter(customer =>
        customer.status.toLowerCase() === statusFilter.toLowerCase()
      );
    }

    if (dateFilter !== 'all') {
      const now = new Date();
      const filterStartDate = new Date();
      const filterEndDate = new Date();

      switch (dateFilter) {
        case 'today':
          filterStartDate.setHours(0, 0, 0, 0);
          filterEndDate.setHours(23, 59, 59, 999);
          filtered = filtered.filter(customer => {
            const orderDate = new Date(customer.date);
            return orderDate >= filterStartDate && orderDate <= filterEndDate;
          });
          break;
        case 'week':
          filterStartDate.setDate(now.getDate() - 7);
          filterStartDate.setHours(0, 0, 0, 0);
          filtered = filtered.filter(customer => {
            const orderDate = new Date(customer.date);
            return orderDate >= filterStartDate;
          });
          break;
        case 'month':
          filterStartDate.setMonth(now.getMonth() - 1);
          filterStartDate.setHours(0, 0, 0, 0);
          filtered = filtered.filter(customer => {
            const orderDate = new Date(customer.date);
            return orderDate >= filterStartDate;
          });
          break;
        case 'year':
          filterStartDate.setFullYear(now.getFullYear() - 1);
          filterStartDate.setHours(0, 0, 0, 0);
          filtered = filtered.filter(customer => {
            const orderDate = new Date(customer.date);
            return orderDate >= filterStartDate;
          });
          break;
        case 'custom':
          if (customStartDate && customEndDate) {
            const startDate = new Date(customStartDate);
            const endDate = new Date(customEndDate);
            startDate.setHours(0, 0, 0, 0);
            endDate.setHours(23, 59, 59, 999);

            filtered = filtered.filter(customer => {
              const orderDate = new Date(customer.date);
              return orderDate >= startDate && orderDate <= endDate;
            });
          }
          break;
      }
    }

    filtered.sort((a, b) => {
      let aValue, bValue;

      switch (sortBy) {
        case 'name':
          aValue = a.name.toLowerCase();
          bValue = b.name.toLowerCase();
          break;
        case 'amount':
          aValue = a.totalAmount;
          bValue = b.totalAmount;
          break;
        case 'date':
          aValue = new Date(a.date);
          bValue = new Date(b.date);
          break;
        case 'customerId':
          aValue = a.customerId.toLowerCase();
          bValue = b.customerId.toLowerCase();
          break;
        default:
          aValue = a.date;
          bValue = b.date;
      }

      if (sortOrder === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });

    setFilteredCustomers(filtered);
    setError(filtered.length === 0 ? 'No customers found matching your criteria.' : '');
  };

  useEffect(() => {
    if (customers.length > 0) {
      setCurrentPage(1);
      applyFiltersAndSort(customers);
    }
  }, [sortBy, sortOrder, statusFilter, dateFilter, searchQuery, customStartDate, customEndDate]);

  const downloadReport = async () => {
    // Enhanced CSV with customer and product details
    const csvData = [
      ['Sr No', 'Customer ID', 'Customer Name', 'Email', 'Phone', 'Address', 'Status', 'Date Created', 'Order ID', 'Product Name', 'Quantity', 'Price', 'Total Price', 'Order Date', 'Order Amount']
    ];

    let rowIndex = 1;

    // Fetch detailed order information for each customer
    for (const customer of filteredCustomers) {
      try {
        const ordersRef = ref(db, 'HTAMS/orders');
        const ordersSnapshot = await get(ordersRef);

        if (ordersSnapshot.exists()) {
          const allOrders = ordersSnapshot.val();
          const customerOrdersList = Object.entries(allOrders)
            .filter(([orderId, order]) => order.customerPhone === customer.phone)
            .map(([orderId, order]) => ({ id: orderId, ...order }));

          if (customerOrdersList.length > 0) {
            // Add each product from each order as a separate row
            customerOrdersList.forEach(order => {
              if (order.items && order.items.length > 0) {
                order.items.forEach(item => {
                  csvData.push([
                    rowIndex++,
                    customer.customerId || 'N/A',
                    customer.name || 'N/A',
                    customer.email || 'N/A',
                    customer.phone || 'N/A',
                    formatAddress(customer.address),
                    customer.status || 'N/A',
                    customer.date || 'N/A',
                    order.id || 'N/A',
                    item.productName || 'N/A',
                    item.quantity || 0,
                    item.price || 0,
                    item.totalPrice || 0,
                    order.orderDate ? new Date(order.orderDate).toLocaleDateString('en-IN') : 'N/A',
                    order.totalAmount || 0
                  ]);
                });
              } else {
                // Order without items
                csvData.push([
                  rowIndex++,
                  customer.customerId || 'N/A',
                  customer.name || 'N/A',
                  customer.email || 'N/A',
                  customer.phone || 'N/A',
                  formatAddress(customer.address),
                  customer.status || 'N/A',
                  customer.date || 'N/A',
                  order.id || 'N/A',
                  'No items',
                  0,
                  0,
                  0,
                  order.orderDate ? new Date(order.orderDate).toLocaleDateString('en-IN') : 'N/A',
                  order.totalAmount || 0
                ]);
              }
            });
          } else {
            // Customer without orders
            csvData.push([
              rowIndex++,
              customer.customerId || 'N/A',
              customer.name || 'N/A',
              customer.email || 'N/A',
              customer.phone || 'N/A',
              formatAddress(customer.address),
              customer.status || 'N/A',
              customer.date || 'N/A',
              'No orders',
              'N/A',
              0,
              0,
              0,
              'N/A',
              0
            ]);
          }
        }
      } catch (error) {
        console.error('Error fetching orders for customer:', customer.phone, error);
      }
    }

    const csvString = csvData.map(row =>
      row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(',')
    ).join('\n');

    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const dateRange = dateFilter === 'custom' ? `${customStartDate}_to_${customEndDate}` : dateFilter;
    a.download = `customers_detailed_report_${dateRange}_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const openModal = (customer) => {
    setSelectedCustomer(customer);
    fetchCustomerOrders(customer);
    setIsEditMode(false);
    setEditValidationErrors({});
  };

  const closeModal = () => {
    setSelectedCustomer(null);
    setCustomerOrders([]);
    setIsEditMode(false);
    setEditValidationErrors({});
  };

  // Edit customer handlers
  const handleEditClick = async () => {
    if (!selectedCustomer) return;

    try {
      // Fetch full customer data from Firebase
      const customerRef = ref(db, `HTAMS/customers/${selectedCustomer.phone}`);
      const customerSnapshot = await get(customerRef);

      if (customerSnapshot.exists()) {
        const customerData = customerSnapshot.val();
        const address = customerData.address || {};

        setEditFormData({
          name: customerData.name || '',
          email: customerData.email || '',
          phone: customerData.phone || selectedCustomer.phone,
          address: address.street || '',
          landmark: address.landmark || '',
          city: address.city || '',
          state: address.state || '',
          district: address.district || '',
          postalCode: address.postalCode || '',
          birthDate: customerData.birthDate || ''
        });
        setIsEditMode(true);
      }
    } catch (error) {
      console.error('Error fetching customer data for edit:', error);
      setError('Failed to load customer data for editing.');
    }
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;

    // If state is changed, clear the district selection
    if (name === 'state') {
      setEditFormData(prev => ({
        ...prev,
        [name]: value,
        district: '' // Clear district when state changes
      }));
    } else {
      setEditFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }

    // Clear validation error for this field when user starts typing
    if (editValidationErrors[name]) {
      setEditValidationErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleCancelEdit = () => {
    setIsEditMode(false);
    setEditValidationErrors({});
  };

  const handleSaveEdit = async () => {
    // Validate form
    const errors = {};
    Object.keys(editFormData).forEach(key => {
      const error = validateField(key, editFormData[key]);
      if (error) {
        errors[key] = error;
      }
    });

    if (Object.keys(errors).length > 0) {
      setEditValidationErrors(errors);
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      // Update customer data in Firebase
      const customerRef = ref(db, `HTAMS/customers/${selectedCustomer.phone}`);
      const customerSnapshot = await get(customerRef);

      if (customerSnapshot.exists()) {
        const existingData = customerSnapshot.val();

        const updatedData = {
          ...existingData,
          name: editFormData.name.trim(),
          email: editFormData.email.trim().toLowerCase(),
          address: {
            street: editFormData.address.trim(),
            landmark: editFormData.landmark.trim(),
            city: editFormData.city.trim(),
            state: editFormData.state.trim(),
            district: editFormData.district.trim(),
            postalCode: editFormData.postalCode.trim()
          },
          birthDate: editFormData.birthDate,
          updatedAt: new Date().toISOString()
        };

        await update(customerRef, updatedData);

        // Update selected customer display
        setSelectedCustomer({
          ...selectedCustomer,
          name: updatedData.name,
          email: updatedData.email,
          address: updatedData.address,
          birthDate: updatedData.birthDate ? new Date(updatedData.birthDate).toLocaleDateString('en-IN', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          }) : null
        });

        setIsEditMode(false);
        setEditValidationErrors({});
        alert('Customer details updated successfully!');
      }
    } catch (error) {
      console.error('Error updating customer:', error);
      setError('Failed to update customer. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'has orders':
        return '#10b981';
      case 'no orders':
        return '#f59e0b';
      default:
        return '#6b7280';
    }
  };

  const getOrderStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'completed':
      case 'delivered':
        return '#10b981';
      case 'pending':
        return '#f59e0b';
      case 'paid':
        return '#059669';
      case 'cancelled':
        return '#ef4444';
      case 'processing':
        return '#3b82f6';
      default:
        return '#6b7280';
    }
  };

  if (loading) {
    return (
      <div className="customers-container">
        {/* <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading customers...</p>
        </div> */}
      </div>
    );
  }

  return (
    <div className="customers-container">
      <div className="header-section">
        <div className="title-section">
          <h2 className="customers-title">
            {isAdmin ? 'All  Customer' : 'My Customers'}
          </h2>
          <p className="subtitle">
            {isAdmin ? 'Manage and view all customer orders' : 'View your customer orders and details'}
          </p>
        </div>

        <div className="header-actions">

          <div className="stats-card">
            <div className="stat-item">
              <span className="stat-number">{filteredCustomers.length}</span>
              <span className="stat-label">Total Customers</span>
            </div>
          </div>
        </div>
      </div>

      <div className="search-section">
        <div className="search-container">
          <div className="search-input-wrapper">
            <span className="search-icon">🔍</span>
            <input
              type="text"
              className="search-input"
              placeholder="Search by Name, Email, Phone, or Customer ID"
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyPress={handleKeyPress}
              aria-label="Search customers"
            />
          </div>
          <button className="search-button" onClick={handleSearch}>
            <span>Search</span>
          </button>
        </div>

        <div className="filter-controls">
          <div className="filter-group">
            <label>Sort by:</label>
            <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
              <option value="date">Date</option>
              <option value="name">Name</option>
              <option value="amount">Amount</option>
              <option value="customerId">Customer ID</option>
            </select>
          </div>

          <div className="filter-group">
            <label>Order:</label>
            <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
              <option value="desc">Descending</option>
              <option value="asc">Ascending</option>
            </select>
          </div>

          <div className="filter-group">
            <label>Status:</label>
            <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
              <option value="all">All Status</option>
              <option value="has orders">Has Orders</option>
              {/* <option value="no orders">No Orders</option> */}
            </select>
          </div>

          <div className="filter-group">
            <label>Date Range:</label>
            <select value={dateFilter} onChange={(e) => setDateFilter(e.target.value)}>
              <option value="all">All Time</option>
              <option value="today">Today</option>
              <option value="week">Last Week</option>
              <option value="month">Last Month</option>
              <option value="year">Last Year</option>
              <option value="custom">Custom Range</option>
            </select>
          </div>

          {dateFilter === 'custom' && (
            <div className="custom-date-range">
              <div className="filter-group">
                <label>Start Date:</label>
                <input
                  type="date"
                  value={customStartDate}
                  onChange={(e) => setCustomStartDate(e.target.value)}
                  className="date-input"
                />
              </div>
              <div className="filter-group">
                <label>End Date:</label>
                <input
                  type="date"
                  value={customEndDate}
                  onChange={(e) => setCustomEndDate(e.target.value)}
                  className="date-input"
                />
              </div>
            </div>
          )}

          <button className="download-button" onClick={downloadReport}>
            <span>📥</span>
            Download Report
          </button>
        </div>
      </div>

      {error && (
        <div className="error-message">
          <span className="error-icon">⚠️</span>
          {error}
        </div>
      )}

      {/* Desktop Table View */}
      <div className="table-section desktop-only">
        <div className="customers-table-wrapper">
          <table className="customers-table" aria-label="Customer Orders Table">
            <thead>
              <tr>
                <th scope="col" aria-label="Serial Number">SR NO</th>
                <th scope="col">CUSTOMER ID</th>
                <th scope="col">CUSTOMER NAME</th>
                <th scope="col">CONTACT INFO</th>
                <th scope="col">ORDER COUNT</th>
                <th scope="col">STATUS</th>
                <th scope="col">DATE</th>
                <th scope="col">ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {currentCustomers.length > 0 ? (
                currentCustomers.map((customer, index) => (
                  <tr key={customer.id} className="customer-row">
                    <td className="serial-number">{indexOfFirstRecord + index + 1}</td>
                    <td className="customer-id">{customer.customerId}</td>
                    <td className="customer-info">
                      <div className="customer-name">{customer.name}</div>
                      {/* <div className="customer-address">{customer.address}</div> */}
                    </td>
                    <td className="contact-info">
                      <div className="email">📧 {customer.email}</div>
                      <div className="phone">📞 {customer.phone}</div>
                    </td>
                    <td className="amount">{customer.quantity}</td>
                    <td>
                      <span
                        className="status-badge"
                        style={{ backgroundColor: getStatusColor(customer.status) }}
                      >
                        {customer.status}
                      </span>
                    </td>
                    <td className="date">{customer.date}</td>
                    <td>
                      <button
                        className="view-button"
                        onClick={() => openModal(customer)}
                        aria-label={`View details for ${customer.name}`}
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="no-data">
                    <div className="no-data-content">
                      <span className="no-data-icon">📋</span>
                      <p>No customers found</p>
                      <span className="no-data-subtitle">Try adjusting your search criteria</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile Card View - Compact Design */}
      <div className="mobile-cards mobile-only">
        {currentCustomers.length > 0 ? (
          currentCustomers.map((customer, index) => (
            <div key={customer.id} className="customer-card-compact">
              <div className="card-header-compact">
                <div className="customer-name-primary">{customer.name}</div>
                <button
                  className="view-details-btn"
                  onClick={() => openModal(customer)}
                  aria-label={`View details for ${customer.name}`}
                >
                  View Details
                </button>
              </div>

              <div className="card-content-compact">
                <div className="secondary-info">
                  <div className="customer-id-info">
                    <span className="id-label">ID:</span>
                    <span className="customer-id-text">#{customer.customerId}</span>
                  </div>
                  <div className="date-info">
                    <span className="date-icon">📅</span>
                    <span className="date-text">{customer.date}</span>
                  </div>
                </div>

                <div className="primary-info">
                  <div className="phone-info">
                    <span className="phone-icon">📞</span>
                    <span className="phone-number">{customer.phone}</span>
                  </div>
                </div>

                <div className="product-info">
                  <span className="product-label">Product:</span>
                  <span className="product-name">{customer.purchasedProduct}</span>
                  <span className="order-count">({customer.quantity} orders)</span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data-card">
            <div className="no-data-content">
              <span className="no-data-icon">📋</span>
              <p>No customers found</p>
              <span className="no-data-subtitle">Try adjusting your search criteria</span>
            </div>
          </div>
        )}
      </div>

      {/* Pagination Controls */}
      <div className="pagination">
        <button
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          Next
        </button>
      </div>

      {/* Modal */}
      {selectedCustomer && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{isEditMode ? 'Edit Customer Details' : 'Customer Details'}</h3>
              <button className="modal-close" onClick={closeModal}>×</button>
            </div>

            <div className="modal-body">
              {/* Compact Customer ID */}
              <div className="customer-id-compact">
                {selectedCustomer.customerId}
              </div>

              {/* Status Badge */}
              <div className="status-section">
                <label>STATUS:</label>
                <span
                  className="status-badge-large"
                  style={{ backgroundColor: getStatusColor(selectedCustomer.status) }}
                >
                  {selectedCustomer.status}
                </span>
              </div>

              {/* Date Created */}
              <div className="date-section">
                <label>DATE CREATED:</label>
                <span className="date-value">{selectedCustomer.date}</span>
              </div>

              {/* Customer Information - Compact */}
              {!isEditMode ? (
                <div className="customer-info-compact">
                  <div className="info-item">
                    <label>Name:</label>
                    <span>{selectedCustomer.name}</span>
                  </div>
                  <div className="info-item">
                    <label>Email:</label>
                    <span>{selectedCustomer.email}</span>
                  </div>
                  <div className="info-item">
                    <label>Phone:</label>
                    <span>{selectedCustomer.phone}</span>
                  </div>
                  {selectedCustomer.birthDate && (
                    <div className="info-item">
                      <label>Birth Date:</label>
                      <span>{selectedCustomer.birthDate}</span>
                    </div>
                  )}
                  <div className="info-item">
                    <label>Address:</label>
                    <span>{formatAddress(selectedCustomer.address)}</span>
                  </div>
                  <div className="info-item">
                    <label>Total Orders:</label>
                    <span>{selectedCustomer.quantity}</span>
                  </div>
                </div>
              ) : (
                <div className="edit-form-compact">
                  <div className="form-grid-compact">
                    <div className="form-group">
                      <label htmlFor="edit-name">Full Name *</label>
                      <input
                        type="text"
                        id="edit-name"
                        name="name"
                        value={editFormData.name}
                        onChange={handleEditInputChange}
                        className={editValidationErrors.name ? 'error' : ''}
                        placeholder="Enter customer's full name"
                      />
                      {editValidationErrors.name && <span className="error-text">{editValidationErrors.name}</span>}
                    </div>

                    <div className="form-group">
                      <label htmlFor="edit-email">Email Address *</label>
                      <input
                        type="email"
                        id="edit-email"
                        name="email"
                        value={editFormData.email}
                        onChange={handleEditInputChange}
                        className={editValidationErrors.email ? 'error' : ''}
                        placeholder="customer@example.com"
                      />
                      {editValidationErrors.email && <span className="error-text">{editValidationErrors.email}</span>}
                    </div>

                    <div className="form-group">
                      <label htmlFor="edit-phone">Phone Number *</label>
                      <input
                        type="tel"
                        id="edit-phone"
                        name="phone"
                        value={editFormData.phone}
                        disabled
                        className="disabled-input"
                        title="Phone number cannot be changed"
                      />
                      <span className="info-text">Phone number cannot be changed</span>
                    </div>

                    <div className="form-group">
                      <label htmlFor="edit-birthDate">Birth Date</label>
                      <input
                        type="date"
                        id="edit-birthDate"
                        name="birthDate"
                        value={editFormData.birthDate}
                        onChange={handleEditInputChange}
                      />
                    </div>

                    <div className="form-group full-width">
                      <label htmlFor="edit-address">Street Address *</label>
                      <textarea
                        id="edit-address"
                        name="address"
                        value={editFormData.address}
                        onChange={handleEditInputChange}
                        className={editValidationErrors.address ? 'error' : ''}
                        placeholder="Enter complete street address"
                        rows="2"
                      />
                      {editValidationErrors.address && <span className="error-text">{editValidationErrors.address}</span>}
                    </div>

                    <div className="form-group">
                      <label htmlFor="edit-landmark">Landmark</label>
                      <input
                        type="text"
                        id="edit-landmark"
                        name="landmark"
                        value={editFormData.landmark}
                        onChange={handleEditInputChange}
                        placeholder="Nearby landmark (optional)"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="edit-city">City *</label>
                      <input
                        type="text"
                        id="edit-city"
                        name="city"
                        value={editFormData.city}
                        onChange={handleEditInputChange}
                        className={editValidationErrors.city ? 'error' : ''}
                        placeholder="Enter city name"
                      />
                      {editValidationErrors.city && <span className="error-text">{editValidationErrors.city}</span>}
                    </div>

                    <div className="form-group">
                      <label htmlFor="edit-state">State *</label>
                      <select
                        id="edit-state"
                        name="state"
                        value={editFormData.state}
                        onChange={handleEditInputChange}
                        className={editValidationErrors.state ? 'error' : ''}
                      >
                        <option value="">Select State</option>
                        {indianStates.map(state => (
                          <option key={state} value={state}>{state}</option>
                        ))}
                      </select>
                      {editValidationErrors.state && <span className="error-text">{editValidationErrors.state}</span>}
                    </div>

                    <div className="form-group">
                      <label htmlFor="edit-district">District *</label>
                      <select
                        id="edit-district"
                        name="district"
                        value={editFormData.district}
                        onChange={handleEditInputChange}
                        className={editValidationErrors.district ? 'error' : ''}
                        disabled={!editFormData.state}
                      >
                        <option value="">Select District</option>
                        {editFormData.state && stateDistricts[editFormData.state]?.map(district => (
                          <option key={district} value={district}>{district}</option>
                        ))}
                      </select>
                      {editValidationErrors.district && <span className="error-text">{editValidationErrors.district}</span>}
                    </div>

                    <div className="form-group">
                      <label htmlFor="edit-postalCode">Postal Code *</label>
                      <input
                        type="text"
                        id="edit-postalCode"
                        name="postalCode"
                        value={editFormData.postalCode}
                        onChange={handleEditInputChange}
                        className={editValidationErrors.postalCode ? 'error' : ''}
                        placeholder="6-digit PIN code"
                        maxLength="6"
                      />
                      {editValidationErrors.postalCode && <span className="error-text">{editValidationErrors.postalCode}</span>}
                    </div>
                  </div>
                </div>
              )}

              <div className="detail-section">
                <h4>📦 Customer Orders</h4>
                {loadingOrders ? (
                  <div className="loading-orders">
                    <div className="spinner"></div>
                    <p>Loading orders...</p>
                  </div>
                ) : customerOrders.length > 0 ? (
                  <div className="orders-list">
                    {customerOrders.map((order, index) => (
                      <div key={order.id} className="order-item">
                        <div className="order-header">
                          <span className="order-number">Order {index + 1}</span>
                          <span className="order-id">ID: {order.id}</span>
                        </div>
                        <div className="order-details">
                          <div className="order-detail">
                            <label>Products:</label>
                            <div className="products-list">
                              {order.items && order.items.length > 0 ? (
                                order.items.map((item, itemIndex) => (
                                  <div key={itemIndex} className="product-item">
                                    <span className="product-name">📦 {item.productName}</span>
                                    <span className="product-quantity">Qty: {item.quantity}</span>
                                    {item.totalPrice > 0 && (
                                      <span className="product-price">₹{item.totalPrice.toLocaleString()}</span>
                                    )}
                                  </div>
                                ))
                              ) : (
                                <span>{order.productName || order.product || 'N/A'}</span>
                              )}
                            </div>
                          </div>

                          <div className="order-details-grid">
                            <div className="order-detail">
                              <label>Total Items:</label>
                              <span>{order.totalItems || order.items?.length || order.quantity || 'N/A'} items</span>
                            </div>

                            <div className="order-detail">
                              <label>Amount:</label>
                              <span>₹{order.totalAmount || order.amount || '0'}</span>
                            </div>

                            <div className="order-detail">
                              <label>Date:</label>
                              <span className="order-date-highlight">
                                {order.orderDate
                                  ? new Date(order.orderDate).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' })
                                  : order.date
                                    ? new Date(order.date).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' })
                                    : order.createdAt
                                      ? new Date(order.createdAt).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' })
                                      : 'N/A'}
                              </span>
                            </div>

                            <div className="order-detail">
                              <label>Status:</label>
                              <span
                                className="order-status"
                                style={{ backgroundColor: getOrderStatusColor(order.status) }}
                              >
                                {order.status || 'N/A'}
                              </span>
                            </div>

                            {order.paymentMethod && (
                              <div className="order-detail">
                                <label>Payment:</label>
                                <span>{order.paymentMethod}</span>
                              </div>
                            )}
                          </div>

                          <div className="order-detail">
                            <label>Placed By:</label>
                            <div className="placed-by-info">
                              <div className="placer-name">
                                <span className="name-icon">👤</span>
                                <span>{order.customerName || 'N/A'}</span>
                              </div>
                              <div className="placer-phone">
                                <span className="phone-icon">📞</span>
                                <span>{order.customerPhone || 'N/A'}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-orders">
                    <span className="no-orders-icon">📦</span>
                    <p>No orders found for this customer</p>
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer">
              {!isEditMode ? (
                <>
                  {isAdmin && (
                    <button className="edit-button" onClick={handleEditClick}>
                      ✏️ Edit Details
                    </button>
                  )}
                  <button className="close-button" onClick={closeModal}>
                    Close
                  </button>
                </>
              ) : (
                <>
                  <button className="cancel-button" onClick={handleCancelEdit} disabled={isSubmitting}>
                    Cancel
                  </button>
                  <button className="submit-button" onClick={handleSaveEdit} disabled={isSubmitting}>
                    {isSubmitting ? 'Saving...' : 'Save Changes'}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Add Customer Modal */}
      {showAddCustomerModal && (
        <div className="modal-overlay" onClick={() => setShowAddCustomerModal(false)}>
          <div className="modal-content add-customer-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Add New Customer</h3>
              <button className="modal-close" onClick={() => setShowAddCustomerModal(false)}>×</button>
            </div>

            <div className="modal-body">
              {error && (
                <div className="error-message" style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#fee', border: '1px solid #fcc', borderRadius: '8px', color: '#c00' }}>
                  {error}
                </div>
              )}

              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className={validationErrors.name ? 'error' : ''}
                    placeholder="Enter customer's full name"
                  />
                  {validationErrors.name && <span className="error-text">{validationErrors.name}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className={validationErrors.email ? 'error' : ''}
                    placeholder="customer@example.com"
                  />
                  {validationErrors.email && <span className="error-text">{validationErrors.email}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className={validationErrors.phone ? 'error' : ''}
                    placeholder="10-digit mobile number"
                    maxLength="10"
                  />
                  {validationErrors.phone && <span className="error-text">{validationErrors.phone}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="birthDate">Birth Date</label>
                  <input
                    type="date"
                    id="birthDate"
                    name="birthDate"
                    value={formData.birthDate}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group full-width">
                  <label htmlFor="address">Street Address *</label>
                  <textarea
                    id="address"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    className={validationErrors.address ? 'error' : ''}
                    placeholder="Enter complete street address"
                    rows="3"
                  />
                  {validationErrors.address && <span className="error-text">{validationErrors.address}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="landmark">Landmark</label>
                  <input
                    type="text"
                    id="landmark"
                    name="landmark"
                    value={formData.landmark}
                    onChange={handleInputChange}
                    placeholder="Nearby landmark (optional)"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="city">City *</label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    className={validationErrors.city ? 'error' : ''}
                    placeholder="Enter city name"
                  />
                  {validationErrors.city && <span className="error-text">{validationErrors.city}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="state">State *</label>
                  <select
                    id="state"
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    className={validationErrors.state ? 'error' : ''}
                  >
                    <option value="">Select State</option>
                    {indianStates.map(state => (
                      <option key={state} value={state}>{state}</option>
                    ))}
                  </select>
                  {validationErrors.state && <span className="error-text">{validationErrors.state}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="district">District *</label>
                  <select
                    id="district"
                    name="district"
                    value={formData.district}
                    onChange={handleInputChange}
                    className={validationErrors.district ? 'error' : ''}
                    disabled={!formData.state}
                  >
                    <option value="">Select District</option>
                    {formData.state && stateDistricts[formData.state]?.map(district => (
                      <option key={district} value={district}>{district}</option>
                    ))}
                  </select>
                  {validationErrors.district && <span className="error-text">{validationErrors.district}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="postalCode">Postal Code *</label>
                  <input
                    type="text"
                    id="postalCode"
                    name="postalCode"
                    value={formData.postalCode}
                    onChange={handleInputChange}
                    className={validationErrors.postalCode ? 'error' : ''}
                    placeholder="6-digit PIN code"
                    maxLength="6"
                  />
                  {validationErrors.postalCode && <span className="error-text">{validationErrors.postalCode}</span>}
                </div>
              </div>
            </div>

            <div style={{ padding: '0 20px 16px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '0.875rem', color: '#374151' }}>
                <input
                  type="checkbox"
                  checked={redirectToQuotation}
                  onChange={(e) => setRedirectToQuotation(e.target.checked)}
                  style={{ width: '16px', height: '16px', accentColor: '#059669' }}
                />
                Redirect to quotation generation after adding customer
              </label>
            </div>

            <div className="modal-footer">
              <button
                className="cancel-button"
                onClick={() => setShowAddCustomerModal(false)}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                className="submit-button"
                onClick={handleAddCustomer}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Adding Customer...' : 'Add Customer'}
              </button>
            </div>
          </div>
        </div>
      )}



      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .customers-container {
          font-family: 'Inter', sans-serif;
          background: var(--mobile-bg-page);
          color: #1e293b;
          padding: 2px;
          min-height: 100vh;
          max-width: 100%;
          overflow-x: hidden;
        }
          .order-details-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
          align-items: start;
        }

        /* Header Section */
        .header-section {
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          padding: 16px;
          margin-bottom: 16px;
          display: grid;
          grid-template-columns: 1fr auto;
          align-items: center;
          gap: 16px;
          background: var(--mobile-bg-primary);
        }

        .header-actions {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .add-customer-btn {
          background: var(--mobile-bg-primary-card);
          color: white;
          border: none;
          padding: 40px 20px;
          border-radius: 8px;
          font-size: 0.875rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
        }

        .add-customer-btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
        }

        .add-customer-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        /* Add Customer Modal Styles */
        .add-customer-modal {
          max-width: 600px;
        }

        /* Quotation Modal Styles */
        .quotation-modal {
          max-width: 1200px;
          width: 90vw;
          max-height: 90vh;
        }

        .form-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
          gap: 6px;
          margin-bottom: 6px;
        }

        .form-group.full-width {
          grid-column: span 2;
        }

        .form-group label {
          font-size: 0.875rem;
          font-weight: 600;

          color: #374151;
        }

        .form-group input,
        .form-group textarea,
        .form-group select {
          padding: 10px 12px;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          font-size: 0.875rem;
          transition: all 0.2s ease;
          font-family: 'Inter', sans-serif;
        }

        .form-group input:focus,
        .form-group textarea:focus,
        .form-group select:focus {
          outline: none;
          border-color: #6366f1;
          box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
        }

        .form-group input.error,
        .form-group textarea.error,
        .form-group select.error {
          border-color: #ef4444;
          box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
        }

        .form-group select:disabled {
          background-color: #f3f4f6;
          color: #9ca3af;
          cursor: not-allowed;
        }

        .error-text {
          font-size: 0.75rem;
          color: #ef4444;
          font-weight: 500;
        }

        .modal-footer {
          display: flex;
          gap: 12px;
          justify-content: flex-end;
          padding: 20px;
          border-top: 1px solid #e5e7eb;
        }

        .cancel-button {
          padding: 10px 20px;
          border: 1px solid #d1d5db;
          background: white;
          color: #6b7280;
          border-radius: 6px;
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .cancel-button:hover:not(:disabled) {
          background: #f9fafb;
          border-color: #9ca3af;
        }

        .cancel-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .submit-button {
          padding: 10px 20px;
          border: none;
          background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
          color: white;
          border-radius: 6px;
          font-size: 0.875rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          box-shadow: 0 2px 4px rgba(99, 102, 241, 0.2);
        }

        .submit-button:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
        }

        .submit-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .title-section {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .customers-title {
          font-size: 20px;
          font-weight: 700;
          color: #ffffff;
          margin: 0;
          line-height: 1.3;
        }

        .subtitle {
          color: #d2d4d5;
          font-size: 13px;
          margin: 0;
          line-height: 1.4;
        }

        .stats-card {
          background: var(--mobile-bg-primary-card);
          padding: 16px 20px;
          border-radius: 10px;
          color: white;
          text-align: center;
          min-width: 120px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .stat-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;
        }

        .stat-number {
          font-size: 32px;
          font-weight: 700;
          display: block;
          line-height: 1;
          color: white;
        }

        .stat-label {
          font-size: 11px;
          opacity: 0.95;
          color: white;
          text-transform: uppercase;
          letter-spacing: 0.8px;
          font-weight: 600;
        }

        /* Search Section */
        .search-section {
          margin-bottom: 20px;
        }

        .search-container {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-bottom: 16px;
        }

        .search-input-wrapper {
          position: relative;
          width: 100%;
        }

        .search-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 16px;
          color: #64748b;
          z-index: 2;
        }

        .search-input {
          width: 100%;
          padding: 14px 16px 14px 44px;
          font-size: 16px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          outline: none;
          background: white;
          box-sizing: border-box;
        }

        .search-input:focus {
          border-color: #6366f1;
          box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
        }

        .search-button {
          width: 100%;
          padding: 14px 20px;
          background: #D65D15;
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .search-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
        }

        /* Filter Controls */
        .filter-controls {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
          padding-top: 16px;
          border-top: 1px solid #e5e7eb;
        }

        .filter-group {
          display: flex;
          flex-direction: column;
          gap: 6px;
          align-items: normal;
        }

        .filter-group label {
          font-size: 0.875rem;
          font-weight: 600;
          color: #374151;
        }

        .filter-group select,
        .filter-group input[type="date"] {
          padding: 12px;
          border: 2px solid #e5e7eb;
          border-radius: 8px;
          font-size: 16px;
          background: white;
          box-sizing: border-box;
        }

        .filter-group select:focus,
        .filter-group input[type="date"]:focus {
          border-color: #6366f1;
          outline: none;
        }

        .custom-date-range {
          display: contents;
        }

        .download-button {
          background: #10b981;
          color: white;
          border: none;
          padding: 14px 20px;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin-top: 30px;
          transition: all 0.2s ease;
        }

        .download-button:hover {
          background: #059669;
          transform: translateY(-1px);
        }

        /* Error Messages */
        .error-message {
          background: #fef2f2;
          border: 1px solid #fecaca;
          color: #dc2626;
          padding: 12px;
          border-radius: 8px;
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        /* Loading States */
        .loading-spinner {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 20px;
          text-align: center;
        }

        .spinner {
          width: 32px;
          height: 32px;
          border: 3px solid #f3f4f6;
          border-top: 3px solid #6366f1;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 12px;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* Show/Hide for Desktop/Mobile */
        .desktop-only {
          display: none;
        }

        .mobile-only {
          display: block;
        }

        /* Mobile Card View - Compact Design */
        .mobile-cards {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .customer-card-compact {
          background: white;
          border-radius: 8px;
          padding: 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          border: 1px solid #e2e8f0;
          margin-bottom: 8px;
        }

        .card-header-compact {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          padding-bottom: 8px;
          border-bottom: 1px solid #f1f5f9;
        }

        .customer-name-primary {
          font-size: 1rem;
          font-weight: 600;
          color: #1e293b;
          flex: 1;
        }

        .view-details-btn {
          background: #3b82f6;
          color: white;
          border: 1px solid #3b82f6;
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 0.75rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .view-details-btn:hover {
          background: #2563eb;
          color: white;
          border-color: #2563eb;
        }

        .card-content-compact {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .secondary-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
          padding-bottom: 6px;
          border-bottom: 1px solid #f8fafc;
        }

        .customer-id-info {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 0.8rem;
        }

        .id-label {
          color: #64748b;
          font-weight: 500;
        }

        .customer-id-text {
          color: #6366f1;
          font-weight: 600;
          font-family: monospace;
        }

        .primary-info {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 12px;
        }

        .phone-info, .date-info {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 0.8rem;
        }

        .phone-icon, .date-icon {
          font-size: 0.75rem;
        }

        .phone-number {
          color: #1e293b;
          font-weight: 500;
        }

        .date-text {
          color: #64748b;
          font-weight: 400;
        }

        .product-info {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 0.8rem;
          flex-wrap: wrap;
        }

        .product-label {
          color: #64748b;
          font-weight: 500;
        }

        .product-name {
          color: #1e293b;
          font-weight: 500;
          flex: 1;
        }

        .order-count {
          color: #6366f1;
          font-weight: 600;
          font-size: 0.75rem;
        }

        .status-badge {
          display: inline-block;
          padding: 4px 8px;
          border-radius: 12px;
          color: white;
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .view-button {
          background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
          color: white;
          border: none;
          padding: 10px 16px;
          border-radius: 8px;
          font-size: 0.875rem;
          font-weight: 600;
          cursor: pointer;
          width: 100%;
          transition: all 0.2s ease;
        }

        .view-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
        }

        /* No Data States */
        .no-data-card {
          background: white;
          border-radius: 12px;
          padding: 40px 20px;
          text-align: center;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          border: 1px solid #e2e8f0;
        }

        .no-data-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
        }

        .no-data-icon {
          font-size: 3rem;
          opacity: 0.5;
        }

        .no-data-subtitle {
          color: #64748b;
          font-size: 0.875rem;
        }

        /* Pagination */
        .pagination {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          margin: 24px 0;
          padding: 0 16px;
        }

        .pagination button {
          background: #6366f1;
          color: white;
          padding: 10px 16px;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          cursor: pointer;
          font-weight: 600;
          min-width: 80px;
          transition: all 0.2s ease;
        }

        .pagination button:hover:not(:disabled) {
          background: #4f46e5;
          transform: translateY(-1px);
        }

        .pagination button:disabled {
          background: #cbd5e1;
          cursor: not-allowed;
        }

        .pagination span {
          font-size: 14px;
          color: #64748b;
          font-weight: 500;
        }

        /* Modal */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 16px;
        }

        .modal-content {
          background: white;
          width: 100%;
          max-width: 600px;
          max-height: 96vh;
          border-radius: 16px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 20px;
          border-bottom: 1px solid #e2e8f0;
          background: #f8fafc;
          flex-shrink: 0;
        }

        .modal-header h3 {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
        }

        .modal-close {
          width: 32px;
          height: 32px;
          border: none;
          background: #f1f5f9;
          border-radius: 8px;
          font-size: 20px;
          color: #64748b;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .modal-close:hover {
          background: #e2e8f0;
        }

        .modal-body {
          flex: 1;
          padding: 0;
          overflow-y: auto;
        }

        /* Compact Mobile-App Style */
        .customer-id-compact {
          font-size: 1.1rem;
          font-weight: 600;
          color: #1e293b;
          padding: 12px 0;
          border-bottom: 1px solid #e5e7eb;
          margin-bottom: 16px;
        }

        .status-section, .date-section {
          margin-bottom: 16px;
        }

        .status-section label, .date-section label {
          font-size: 0.75rem;
          font-weight: 700;
          color: #64748b;
          letter-spacing: 0.5px;
          display: block;
          margin-bottom: 8px;
        }

        .status-badge-large {
          display: inline-block;
          padding: 10px 20px;
          border-radius: 8px;
          color: white;
          font-weight: 700;
          font-size: 0.9rem;
          text-transform: uppercase;
          width: 100%;
          text-align: center;
        }

        .date-value {
          font-size: 0.95rem;
          color: #1e293b;
          font-weight: 500;
        }

        .customer-info-compact {
          background: #f8fafc;
          border-radius: 8px;
          padding: 12px;
          margin-bottom: 16px;
          border: 1px solid #e5e7eb;
        }

        .info-item {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          padding: 8px 0;
          border-bottom: 1px solid #e5e7eb;
          gap: 12px;
        }

        .info-item:last-child {
          border-bottom: none;
        }

        .info-item label {
          font-size: 0.85rem;
          font-weight: 600;
          color: #64748b;
          min-width: 80px;
          flex-shrink: 0;
        }

        .info-item span {
          font-size: 0.9rem;
          color: #1e293b;
          text-align: right;
          word-break: break-word;
        }

        .detail-section {
          margin-bottom: 24px;
        }

        .detail-section h4 {
          font-size: 1.125rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 16px;
          padding-bottom: 8px;
          border-bottom: 2px solid #e2e8f0;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .detail-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
        }

        .detail-item {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .detail-item.full-width {
          grid-column: 1 / -1;
        }

        .detail-item label {
          font-size: 0.75rem;
          font-weight: 600;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .detail-item span {
          font-size: 1rem;
          color: #1e293b;
          font-weight: 500;
          word-break: break-word;
        }

        /* Orders in Modal */
        .orders-list {
          max-height: 400px;
          overflow-y: auto;
          margin-top: 12px;
            scrollbar-width: none;
        }

        .order-item {
          padding: 16px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          margin-bottom: 12px;
        }

        .order-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
          padding-bottom: 8px;
          border-bottom: 1px solid #e2e8f0;
        }

        .order-number {
          font-weight: 600;
          color: #374151;
        }

        .order-id {
          font-family: monospace;
          font-size: 0.75rem;
          color: #6b7280;
        }

        .order-details {
          display: grid;
          grid-template-columns: 1fr;
          gap: 12px;
        }

        .order-detail {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .order-detail label {
          font-size: 0.75rem;
          font-weight: 600;
          color: #6b7280;
          text-transform: uppercase;
        }

        .products-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-top: 4px;
        }

        .product-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 12px;
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          flex-wrap: wrap;
          margin-bottom: 8px;
        }

        .product-name {
          font-weight: 600;
          color: #1f2937;
          flex: 1;
          min-width: 150px;
          font-size: 0.9rem;
        }

        .product-quantity {
          background: #dbeafe;
          color: #1d4ed8;
          padding: 4px 10px;
          border-radius: 6px;
          font-size: 0.8rem;
          font-weight: 700;
          white-space: nowrap;
        }

        .product-price {
          color: #059669;
          font-weight: 700;
          font-size: 0.9rem;
          background: #d1fae5;
          padding: 4px 10px;
          border-radius: 6px;
          white-space: nowrap;
        }

        .placed-by-info {
          display: flex;
          flex-direction: column;
          gap: 4px;
          margin-top: 4px;
        }

        .placer-name, .placer-phone {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 0.875rem;
        }

        .placer-name {
          color: #1f2937;
          font-weight: 600;
        }

        .placer-phone {
          color: #6b7280;
          font-weight: 500;
        }

        .name-icon, .phone-icon {
          font-size: 0.75rem;
        }

        .order-date-highlight {
          color: #3b82f6;
          font-weight: 700;
          font-size: 0.875rem;
        }

        .order-detail span {
          font-size: 0.875rem;
          color: #374151;
        }

        .order-status {
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 0.75rem;
          font-weight: 500;
          color: white;
          text-transform: capitalize;
          display: inline-block;
          margin-top: 2px;
        }

        .loading-orders,
        .no-orders {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 40px 20px;
          text-align: center;
          color: #6b7280;
        }

        .no-orders-icon {
          font-size: 2rem;
          margin-bottom: 8px;
        }

        .modal-footer {
          padding: 6px 20px;
          border-top: 1px solid #e2e8f0;
          background: #f8fafc;
          flex-shrink: 0;
          padding-bottom: 35px;
        }

        .close-button {
          background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
          color: white;
          border: none;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          width: 100%;
          transition: all 0.2s ease;
        }

        .close-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
        }

        /* Edit Button */
        .edit-button {
          background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
          color: white;
          border: none;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          box-shadow: 0 2px 4px rgba(245, 158, 11, 0.2);
        }

        .edit-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
        }

        /* Edit Form Styles */
        .edit-form-compact {
          background: #f8fafc;
          border-radius: 8px;
          padding: 16px;
          margin-bottom: 16px;
          border: 1px solid #e5e7eb;
        }

        .form-grid-compact {
          display: grid;
          grid-template-columns: 1fr;
          gap: 12px;
        }

        .disabled-input {
          background-color: #f3f4f6 !important;
          color: #9ca3af !important;
          cursor: not-allowed !important;
          opacity: 0.7;
        }

        .info-text {
          font-size: 0.7rem;
          color: #6b7280;
          font-style: italic;
          margin-top: 2px;
        }

        /* Tablet Styles (768px and up) */
        @media (min-width: 768px) {
          .customers-container {
            padding: 4px;
          }
          
          .header-section {
            padding: 24px 28px;
            gap: 24px;
            border-radius: 16px;
            margin-bottom: 20px;
          }

          .title-section {
            gap: 8px;
          }

          .customers-title {
            font-size: 24px;
            margin-bottom: 8px;
          }

          .subtitle {
            font-size: 14px;
          }

          .stats-card {
            min-width: 200px;
            padding: 3px 8px;
            border-radius: 12px;
          }

          .stat-number {
            font-size: 40px;
          }

          .stat-label {
            font-size: 12px;
          }
          
          .search-container {
            flex-direction: row;
            max-width: 600px;
          }
          
          .search-input-wrapper {
            flex: 1;
          }
          
          .search-button {
            width: auto;
          }
          
          .filter-controls {
            grid-template-columns: repeat(5, 1fr);
            gap: 16px;
          }
          
          .download-button {
            width: auto;
            margin-left: auto;
          }
          
          .detail-grid {
            grid-template-columns: 1fr 1fr;
          }
          
          .custom-date-range {
            display: contents;
          }

          .order-details {
            grid-template-columns: 1fr 1fr;
          }

          .form-grid-compact {
            grid-template-columns: repeat(2, 1fr);
          }

          .edit-button,
          .close-button {
            width: auto;
          }

          .modal-footer {
            display: flex;
            gap: 12px;
            justify-content: flex-end;
          }
        }

        /* Desktop Styles (1024px and up) */
        @media (min-width: 1024px) {
          .customers-container {
            padding: 3px;
            max-width: 100%;
            margin: 0 auto;
          }
          
          /* Show table, hide cards */
          .desktop-only {
            display: block;
          }
          
          .mobile-only {
            display: none;
          }
          
          .table-section {
            background: white;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
            border: 1px solid #e2e8f0;
          }
          
          .customers-table-wrapper {
            overflow-x: auto;
          }
          
          .customers-table {
            width: 100%;
            border-collapse: collapse;
            min-width: 900px;
          }
          
          .customers-table th,
          .customers-table td {
            padding: 16px;
            text-align: left;
            border-bottom: 1px solid #e2e8f0;
          }
          
          .customers-table th {
            background: var(--mobile-bg-primary);
            color: white;
            font-weight: 600;
            font-size: 14px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            position: sticky;
            top: 0;
            z-index: 10;
          }
          
          .customer-row:hover {
            background: #f8fafc;
          }
          
          .serial-number {
            background: transparent;
            color: #6366f1;
            border-radius: 0;
            width: auto;
            height: auto;
            font-weight: 600;
            text-align: center;
            position: static;
            display: table-cell;
          }

          .customer-id {
            font-family: monospace;
            color: #6366f1;
            font-weight: 600;
          }
          
          .customer-info .customer-name {
            font-size: 1rem;
            font-weight: 600;
            color: #1e293b;
            margin-bottom: 4px;
          }

          .customer-info .customer-address {
            font-size: 0.875rem;
            color: #64748b;
            line-height: 1.4;
          }

          .contact-info .email,
          .contact-info .phone {
            font-size: 0.875rem;
            color: #475569;
            margin-bottom: 2px;
          }

          .amount {
            font-weight: 600;
            color: #1e293b;
          }

          .date {
            color: #64748b;
            font-size: 0.875rem;
          }
          
          .view-button {
            width: auto;
            margin-top: 0;
            padding: 8px 16px;
            font-size: 0.875rem;
          }

          .no-data {
            text-align: center;
            padding: 60px 20px;
          }

          .modal-content {
            max-width: 800px;
          }
        }
      `}</style>
    </div>
  );
};

export default Customers;
